/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import type { ContentstackConfig } from './types';

export const CONTENTSTACK_DELIVERY_TOKEN_ENV = 'CONTENTSTACK_DELIVERY_TOKEN';
export const CONTENTSTACK_PREVIEW_TOKEN_ENV = 'CONTENTSTACK_PREVIEW_TOKEN';

export const CONTENTSTACK_PREVIEW_HOST = 'rest-preview.contentstack.com';
export const CONTENTSTACK_IMAGE_HOST = 'https://images.contentstack.io';
export const CONTENTSTACK_CDN_HOST = 'https://cdn.contentstack.io';
export const CONTENTSTACK_PERSONALIZE_EDGE_HOST = 'https://personalize-edge.contentstack.com';
export const LYTICS_HOST = 'https://c.lytics.io';

export const DEFAULT_CONTENTSTACK_CONFIG: ContentstackConfig = {
    enabled: false,
    stack: '',
    environment: '',
    branch: 'main',
    language: 'en-us',
    contentTypeLookup: [],
    previewHost: CONTENTSTACK_PREVIEW_HOST,
    pageSize: 12,
    personalize: {
        enabled: false,
        projectUid: '',
    },
    lytics: {
        enabled: false,
        accountId: '',
    },
};

export const CONTENTSTACK_CSP_HOSTS = [
    CONTENTSTACK_IMAGE_HOST,
    CONTENTSTACK_CDN_HOST,
    `https://${CONTENTSTACK_PREVIEW_HOST}`,
    CONTENTSTACK_PERSONALIZE_EDGE_HOST,
    LYTICS_HOST,
] as const;
